/** student/progress — HOOKS. Refetches on window focus (global default) so the
 * portal shows fresh XP/badges after returning from the game tab. */
import { useQuery } from '@tanstack/react-query';
import { studentProgressApi } from './api';
import { studentProgressKeys } from './keys';

export function useStudentProgress(enabled = true) {
  return useQuery({
    queryKey: studentProgressKeys.all(),
    queryFn: () => studentProgressApi.fetchMine(),
    enabled,
  });
}
